// extracted by mini-css-extract-plugin
export default {"footerLinks":"FooterLinks_footerLinks__5evsj","footerLink":"FooterLinks_footerLink__NlsR7"};